import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ExpectedEnergyLossComponent } from "../../../../shared/widgets/expected-energy-loss/expected-energy-loss.component";
import { DoughnutChartComponent } from "../widgets/doughnut-chart/doughnut-chart.component";
import { BarChartComponent } from "../widgets/bar-chart/bar-chart.component";
import { LineChartComponent } from "../widgets/line-chart/line-chart.component";
import { WeatherReportComponent } from "../../../../shared/widgets/weather-report/weather-report.component";
import { ActivatedRoute } from "@angular/router";
import { ASSET_TYPES } from "../../../../enums/assetTypes.enum";
import { LocationEnergyToolService } from "./location-energy-tool/location-energy-tool.service";
import { ChartChangeTimeEvent } from "../../../../models/ui/chartData";
import { SimplebarAngularModule } from "simplebar-angular";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  standalone: true,
  selector: "app-location-energy",
  imports: [
    ExpectedEnergyLossComponent,
    DoughnutChartComponent,
    BarChartComponent,
    LineChartComponent,
    WeatherReportComponent,
    SimplebarAngularModule,
  ],
  templateUrl: "./location-energy.component.html",
  styleUrl: "./location-energy.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [LocationEnergyToolService],
})
export class LocationEnergyComponent {
  private route = inject(ActivatedRoute);
  public sourceType = ASSET_TYPES.LOCATION;
  public sourceId!: string;
  public energyToolFacade = inject(LocationEnergyToolService);
  constructor() {
    this.route.url.pipe(takeUntilDestroyed()).subscribe((url) => {
      this.sourceId = url[1].path;
      this.energyToolFacade.loadInitialState(this.sourceId);
    });
  }

  /**
   * Handler for time range change events emitted by the expected energy loss widget.
   * @param changeEvent The new time range chosen by the user.
   */
  public onChangeTimeExpecteEnergyLoss(changeEvent: string) {
    this.energyToolFacade.updateEnergyLossForTimeWindow(this.sourceId, changeEvent);
  }

  /**
   * Handler for time range change events emitted by the doughnut chart.
   * @param changeEvent The new time range chosen by the user.
   */
  public onChangeTimeDoughnutChart(changeEvent: string) {
    this.energyToolFacade.updateDoughnutChartForTimeRange(this.sourceId, changeEvent);
  }

  /**
   * Handler for time range change events emitted by the bar chart.
   * @param changeEvent The new time range chosen by the user.
   */
  public onChangeTimeBarChart(changeEvent: ChartChangeTimeEvent) {
    this.energyToolFacade.updateBarChartForTimeRange(
      changeEvent.start,
      changeEvent.end,
      changeEvent.timeFrame,
      this.sourceId,
      changeEvent.assetLabels?.[0]
    );
  }
  /**
   * Handler for time range change events emitted by the line chart.
   * @param changeEvent The new time range chosen by the user.
   */
  public onChangeTimeLineChart(changeEvent: ChartChangeTimeEvent) {
    this.energyToolFacade.updateLineChartForTimeRange(
      changeEvent.start,
      changeEvent.end,
      changeEvent.timeFrame,
      this.sourceId
    );
  }
}
